import axios from "axios";
import { useToast } from "vue-toastification";

export default {
  namespaced: true,
  state: {
    user: [],
    status: {
      updateUser: {
        loading: false,
        error: "",
      },
    },
  },
  getters: {
    getUser: (state) => state.User,
    status: (state) => state.status,
  },
  actions: {
    async updateUserDetail({ commit }, User) {
      commit("setLoading", {
        dataName: "updateUser",
        status: true,
      });
      let token = localStorage.getItem("token");
      console.log(User);
      try {
        let { data } = await axios.patch(
          process.env.VUE_APP_API_URL + "/api/user/update",
          User,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("updateuser", data);
        this.dispatch("auth/updateUserDetails", User)
        commit("setLoading", {
          dataName: "updateUser",
          status: false,
        });
        useToast().success('Profile Updated', {timeout : 3000})
      } catch (error) {
        console.log(error)
        // useToast().error(JSON.stringify(error.response.data.errors), {
        //   timeout: 3000,
        // });
        commit("setLoading", {
          dataName: "updateUser",
          status: false,
        });
        commit("setError", {
          dataName: "updateUser",
          error: error.response.data,
        });
      }
    },
  },
  mutations: {
    setUser: (state, payload) => {
      state.User = payload;
    },
    setLoading: (state, { dataName, status }) => {
      state.status[dataName].loading = status;
    },
    setError: (state, { dataName, error }) => {
      state.status[dataName].error = error;
    },
  },
};
